import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from "react-redux";
import '../../../LinkModal.css';

import LogoLink from '../../../beatport/svg/LogoLink';

function Access({ cancelClick, modalHasEntered }) {
  const storeAuth = useSelector( state => state.storeAuth );
  const signup = () => { storeAuth.registration(false)  }
  const login = () => { storeAuth.signin(false) }
  return (
    <div className={`flexColumn cta pm-no-sub`}>
      <div className={`flexColumn modalV2 bottom-reduce`}>
        <div className={`flexColumn body`} >
          <div className={`logo center`}>
            <LogoLink />
          </div>
          <div className={`title`}>A free Beatport account is required to DJ.</div>
          <div className={`flexColumn`} style={{gap: 8, alignItems: 'flex-start'}}>
            <span>* 2-minute previews on Web, Mobile & DJ app</span>
            <span>* Create and manage unlimited playlists.</span>
            <span>* Purchase and download tracks and releases.</span>
          </div>
          <div className={`flexRow group-cta`}>
            <div className={`cta primary half`} onClick={signup}>Sign up</div>
            <div className={`cta transparent-grey half`} onClick={login}>Log in</div>
          </div>
        </div>
      </div>
    </div>
  )
}

Access.propTypes = {
  cancelClick: PropTypes.func,
  modalHasEntered: PropTypes.bool
}

export default Access;
